import axios from "axios";


export const postData = async (url, headers, data) => {
  try{
      const res = await axios.post(url, data, {headers: headers})
      return res      
    }catch(error){
      if(error.request){
        alert("Request Error: " + error.message)
      }else if(error.response){
        alert("Response Error: " + error)
      }else{
        alert("Other Error: " + error)
      }
      //alert(error)
      //console.log(error)
    }
}

export const getData = async (url, headers, params) => {
    try{
        const res = await axios.get(url, {params:params, headers: headers})
        return res    
      }catch(error){
        console.log(error)
      }
}

export const putData = async (url, headers, data) => {
  try{
      const res = await axios.put(url, data, {headers: headers})
      return res
    }catch(error){
      console.log(error)
    }
}

export const deleteData = async (url, headers, params) => {
  try{
      const res = await axios.delete(url, {params:params, headers: headers});
      return res
    }catch(error){
      console.log(error)
    }
}